import React from 'react';
import InfoBox from '@appComponents/InfoBox/InfoBox';

import * as style from './WarningBoxStyles.module.scss'

type Props = {
  texts: React.ReactNode[];
};

export const WarningBox = ({ texts }: Props) => (
  <InfoBox className={style.warning}>
    <span className={`fa fa-exclamation-triangle ${style.warningIcon}`} />
    <div className={style.warningText}>
      <p><b>Warning!</b></p>
      <br/>
      {texts.map((text, index) => (<p key={index}>{text}</p>))}
    </div>
  </InfoBox>
);
